import { CheckIcon } from '@repo/studio-design-system-ui-icons/general/check'
import { m } from 'framer-motion'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'

export function SuccessIndicator({ label }: { label?: string }) {
  const t = useStudioTranslate()

  return (
    <m.span
      key="success"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.3 } }}
      exit={{ opacity: 0, transition: { duration: 0.2 } }}
      className="flex items-center"
    >
      <CheckIcon className="!mr-1 !size-4" />
      <span>{label ?? t('studio.components.success')}</span>
    </m.span>
  )
}
